module.exports = __webpack_public_path__ + "static/media/uw_header.a8e22445.png";